const footerClasses = {
  footer: 'bg-slate-800 rounded-lg shadow m-4',
  footerContainer: 'w-full container mx-auto p-4 md:px-6 md:py-8',
  footerLogo: 'sm:flex sm:items-center sm:justify-between',
  footerLogoImg: 'h-6 mr-3 sm:h-10',
  footerTitle: 'self-center text-2xl font-semibold whitespace-nowrap',
  footerLinks:
    'flex flex-wrap items-center mb-6 text-sm text-slate-400 sm:mb-0',
  footerLink: 'mr-4 hover:underline md:mr-6',
  footerCopy: 'block text-sm text-slate-400 sm:text-center',
  footerCopyLink: 'hover:underline',
  footerRule: 'my-6 border-slate-400 sm:mx-auto lg:my-8"',
}

export default footerClasses
